import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Link from 'flarum/common/components/Link';
import UserCard from 'flarum/forum/components/UserCard';
import UserControls from 'flarum/forum/utils/UserControls';
import icon from 'flarum/common/helpers/icon';
export default function enhanceUserDirectoryCards(compat) {
  const UserDirectoryUserCard = compat['fof/user-directory/forum/components/UserDirectoryUserCard'] || compat['components/UserDirectoryUserCard'] || flarum.extensions['fof-user-directory'] && flarum.extensions['fof-user-directory'].UserDirectoryUserCard;
  const SmallUserCard = compat['fof/user-directory/forum/components/SmallUserCard'] || compat['components/SmallUserCard'] || flarum.extensions['fof-user-directory'] && flarum.extensions['fof-user-directory'].SmallUserCard;
  function applyCardEnhancements(items) {
    const user = this.attrs.user;
    if (!user) return;

    // 1. Sustituir contadores genéricos por bloque estadístico claro y diferenciado
    if (items.has('discussion-count')) {
      items.remove('discussion-count');
    }
    if (items.has('comment-count')) {
      items.remove('comment-count');
    }
    const discussionCount = user.discussionCount() || 0;
    const commentCount = user.commentCount() || 0;
    items.add('user-directory-stats', m('div', {
      className: 'UserDirectory-statsGrid'
    }, [m('div', {
      className: 'UserDirectory-statBox UserDirectory-statBox--discussions',
      title: app.translator.trans('nagusi-user-directory.forum.discussions_tooltip')
    }, [icon('fas fa-bullhorn', {
      className: 'UserDirectory-statIcon'
    }), m('div', {
      className: 'UserDirectory-statContent'
    }, [m('span', {
      className: 'UserDirectory-statCount'
    }, discussionCount.toLocaleString()), m('span', {
      className: 'UserDirectory-statLabel'
    }, app.translator.trans('nagusi-user-directory.forum.discussions_label', {
      count: discussionCount
    }))])]), m('div', {
      className: 'UserDirectory-statBox UserDirectory-statBox--comments',
      title: app.translator.trans('nagusi-user-directory.forum.comments_tooltip')
    }, [icon('fas fa-comments', {
      className: 'UserDirectory-statIcon'
    }), m('div', {
      className: 'UserDirectory-statContent'
    }, [m('span', {
      className: 'UserDirectory-statCount'
    }, commentCount.toLocaleString()), m('span', {
      className: 'UserDirectory-statLabel'
    }, app.translator.trans('nagusi-user-directory.forum.comments_label', {
      count: commentCount
    }))])])]), 70);

    // 2. Barra de Acciones Rápidas (Quick Actions)
    const quickActions = [];

    // Acción: Estadísticas del Forero
    quickActions.push(m(Link, {
      className: 'Button Button--link UserDirectory-actionBtn UserDirectory-actionBtn--stats',
      href: app.route('userStats', {
        username: user.username()
      }),
      title: app.translator.trans('nagusi-user-directory.forum.action_stats_tooltip')
    }, [icon('fas fa-chart-pie'), m('span', null, app.translator.trans('nagusi-user-directory.forum.action_stats'))]));

    // Acción: Logros del Forero
    quickActions.push(m(Link, {
      className: 'Button Button--link UserDirectory-actionBtn UserDirectory-actionBtn--achievements',
      href: app.route('userAchievements', {
        username: user.username()
      }),
      title: app.translator.trans('nagusi-user-directory.forum.action_achievements_tooltip')
    }, [icon('fas fa-trophy'), m('span', null, app.translator.trans('nagusi-user-directory.forum.action_achievements'))]));

    // Acción: Ficha de Personaje (Informe del Míster) - Solo visible si ya tiene ficha
    const hasSheet = !!user.attribute('hasCharacterSheet');
    if (hasSheet) {
      quickActions.push(m(Link, {
        className: 'Button Button--link UserDirectory-actionBtn UserDirectory-actionBtn--sheet has-sheet',
        href: app.route('userCharacterSheet', {
          username: user.username()
        }),
        title: app.translator.trans('nagusi-user-directory.forum.action_character_sheet_tooltip')
      }, [icon('fas fa-id-card'), m('span', null, app.translator.trans('nagusi-user-directory.forum.action_character_sheet'))]));
    }

    // Acción: Ignorar / Silenciar
    const currentUser = app.session.user;
    if (currentUser && currentUser.id() !== user.id() && typeof user.canBeIgnored === 'function' && user.canBeIgnored()) {
      const isIgnored = typeof user.ignored === 'function' && user.ignored();
      if (isIgnored) {
        quickActions.push(m('button', {
          className: 'Button Button--link UserDirectory-actionBtn UserDirectory-actionBtn--unignore is-ignored',
          type: 'button',
          title: app.translator.trans('nagusi-user-directory.forum.action_unignore_tooltip'),
          onclick: e => {
            e.preventDefault();
            e.stopPropagation();
            const confirmMsg = app.translator.trans('bizkaitarra-ignore-users.forum.user_controls.unignore_confirmation') || '¿Seguro que quieres dejar de ignorar a este usuario?';
            if (confirm(confirmMsg)) {
              user.save({
                ignored: false
              }).then(() => m.redraw());
            }
          }
        }, [icon('fas fa-user-check'), m('span', null, app.translator.trans('nagusi-user-directory.forum.action_unignore'))]));
      } else {
        quickActions.push(m('button', {
          className: 'Button Button--link UserDirectory-actionBtn UserDirectory-actionBtn--ignore',
          type: 'button',
          title: app.translator.trans('nagusi-user-directory.forum.action_ignore_tooltip'),
          onclick: e => {
            e.preventDefault();
            e.stopPropagation();
            if (UserControls) {
              const controls = UserControls.userControls(user);
              if (controls && controls.has('ignore')) {
                const ignoreBtn = controls.get('ignore');
                if (ignoreBtn && ignoreBtn.attrs && typeof ignoreBtn.attrs.onclick === 'function') {
                  ignoreBtn.attrs.onclick();
                  return;
                }
              }
            }
            user.save({
              ignored: true,
              ignoreLevel: 0
            }).then(() => {
              app.alerts.show({
                type: 'success'
              }, app.translator.trans('bizkaitarra-ignore-users.forum.ignore_modal.success_message'));
              m.redraw();
            });
          }
        }, [icon('fas fa-user-slash'), m('span', null, app.translator.trans('nagusi-user-directory.forum.action_ignore'))]));
      }
    }
    items.add('quick-actions', m('div', {
      className: 'UserDirectory-actions'
    }, quickActions), -50);
  }
  if (UserDirectoryUserCard) {
    extend(UserDirectoryUserCard.prototype, 'infoItems', function (items) {
      applyCardEnhancements.call(this, items);
    });
  }
  if (SmallUserCard) {
    extend(SmallUserCard.prototype, 'infoItems', function (items) {
      applyCardEnhancements.call(this, items);
    });
  }

  // Fallback directo en UserCard para tarjetas de directorio
  extend(UserCard.prototype, 'infoItems', function (items) {
    if (!this.attrs.className || !this.attrs.className.includes('UserCard--directory')) {
      return;
    }
    applyCardEnhancements.call(this, items);
  });
}
flarum.reg.add('nagusi-match-ratings', 'forum/user-directory/enhanceUserDirectoryCards', enhanceUserDirectoryCards);